<div class="profile-public">
  <div class="profile-public__title">
    <h2>{{ 'PROFIL' | translate }}</h2>
  </div>
  <div *ngIf="user$ | async" class="profile-public__content">
    <div>{{ 'Öffentliches Profil von' | translate }}</div>
    <h1>
      {{ nickname$ | async }}
      <span class="profile-public__ranger-badge">
        <button
          mat-icon-button
          matTooltip="{{
            'PhenoRanger sind speziell ausgebildete Personen, welche Daten zu zusätzlichen Arten erfassen können. Für weitere Informationen, oder um selbst PhenoRanger zu werden, wenden Sie sich an pheno.rangers@wsl.ch.'
              | translate
          }}"
          *ngIf="isRanger$ | async"
        >
          <mat-icon svgIcon="ranger-badge"></mat-icon>
        </button>
      </span>
      <span class="profile-public__badge">
        <button mat-icon-button [appCopyClipboard]="profileLink" (copied)="notifyCopied()">
          <mat-icon svgIcon="copylink"></mat-icon>
        </button>
      </span>
    </h1>
    <app-user-subscription-button mode="BUTTON" [userId]="userId" *ngIf="isLoggedIn"></app-user-subscription-button>
  </div>
</div>
